import { useField } from 'formik';

import { InputWrapper } from '../InputWrapper';
import { IInlineSelectItem, InlineSelect } from './InlineSelect';

export interface IInlineSelectFieldProps {
  labelText: string;
  name: string;
  helperText?: string;
  isDisabled?: boolean;
  items: IInlineSelectItem[];
  className?: string;
  selectAllLabel?: string;
}

export const InlineSelectField: React.FC<IInlineSelectFieldProps> = (props) => {
  const { name, labelText, helperText, isDisabled, items, className, selectAllLabel } = props;
  const [field, meta, helpers] = useField({ name });

  return (
    <InputWrapper
      labelText={labelText}
      invalidText={meta.touched ? meta.error : undefined}
      helperText={helperText}
      noLabel
    >
      <InlineSelect
        items={items}
        selectedItems={field.value}
        onSelect={helpers.setValue}
        onBlur={() => helpers.setTouched(true)}
        isDisabled={isDisabled}
        isInvalid={Boolean(meta.touched && meta.error)}
        className={className}
        selectAllLabel={selectAllLabel}
      />
    </InputWrapper>
  );
};
